import React, {
  FC,
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react"
import { useCreation } from "ahooks"
import echarts, { EChartOption } from "echarts"
import LayerIndoor from "./components/LayerIndoor"
import LayerAreaGeo from "./components/LayerAreaGeo"
import LayerHeat from "./components/LayerHeat"
import LayerAreaHeat from "./components/LayerAreaHeat"
import LabelMarker from "./components/LabelMarker"
import Env from "@util/env"

import "echarts-amap"
import "./index.scss"
import { useSetState } from "@/reactUse"
import { useHistory } from "react-router-dom"
const Map: FC<any> = (props) => {
  const history = useHistory()
  const chartsDomId = useMemo(() => {
    return "chartMap_" + Math.round(Math.random() * 10000000).toString(16)
  }, [])
  const refCon = useRef()
  const initialScale = useMemo(() => {
    return Math.max(1, Env.getScale())
  }, [])
  const [mapIns, setMapIns] = useState()
  const [chartIns, setChartIns] = useState<any>()
  const [state, setState] = useSetState<any>({
    scaleX: initialScale,
    scaleY: initialScale,
    w: "100%",
    h: "100%",
    fullScreen: false,
  })
  const [zoom, setZoom] = useState(props.zoom)
  const [center, setCenter] = useState(props.center)
  const [ready, setReady] = useState(false)

  // useMemo(() => {
  //   setZoom(props.zoom)
  // }, [props.zoom])
  // console.log("props.zoom", props.zoom)
  // useMemo(() => {
  //   setCenter(props.center)
  // }, [props.center])
  // console.log("props.center", props.center)

  const initialOption = useCreation<EChartOption | any>(() => {
    let opt = {
      animation: false,
      amap: {
        zoom: props.zoom,
        expandZoomRange: true,
        zooms: [3, 22],
        scale: 2,
        // viewMode: "3D",
        // size: "800*800",
        mapStyle: "amap://styles/blue", //地图主题
        center: props.center, //中心点
        rotation: 0, //顺时针旋转角度
        resizeEnable: true,
        zlevel: 999,
      },
      series: [],
    }

    return opt
  }, [])

  useMemo(() => {
    window.AMap.plugin("AMap.CustomLayer", () => {
      setReady(true)
    })
  }, [setReady])
  // transform map
  useEffect(() => {
    let con = refCon.current
    if (!con) {
      return
    }
    // @ts-ignore
    setState({
      // @ts-ignore
      w: con.offsetWidth / state.scaleX,
      // @ts-ignore
      h: con.offsetHeight / state.scaleY,
    })
  }, [refCon])
  // 全屏地图
  const setMapFullScreen = useCallback(() => {
    // let w = document.body.offsetWidth
    // let h = document.body.offsetHeight
    // setState({ fullScreen: true, scaleX: w / state.w, scaleY: h / state.h })
    props.onChangeMapState &&
      props.onChangeMapState({
        center: [121.608801296660304, 31.184597642924776],
        zoom: 20,
        series: [],
        currentIdx: null,
      })
    // history.push("/map")
  }, [setState, props.onChangeMapState])
  useEffect(() => {
    let dom = document.getElementById(chartsDomId)
    if (!dom) {
      return
    }
    // @ts-ignore
    var chartsIns = echarts.init(dom)
    chartsIns.setOption(initialOption)
    setChartIns(chartsIns)

    //@ts-ignore
    var map = chartsIns.getModel().getComponent("amap").getAMap()
    map &&
      map.on("zoomend", () => {
        setZoom(map.getZoom())
      })
    setMapIns(map)
    return () => {
      map && map.destroy()
      chartsIns.clear()
      chartsIns.dispose()
    }
  }, [ready, initialOption])

  useMemo(() => {
    // @ts-ignore
    mapIns && mapIns.setZoom(props.zoom)
  }, [mapIns, props.zoom])
  useMemo(() => {
    // @ts-ignore
    mapIns && mapIns.setCenter(props.center)
  }, [mapIns, props.center])
  useMemo(() => {
    // @ts-ignore
    // chartIns && chartIns.clear()
    chartIns &&
      chartIns.setOption({ series: state.fullScreen ? [] : props.series })
  }, [chartIns, setState, props.series, state.fullScreen])
  const wrapperStyle: any = useMemo(() => {
    let s: any = {}
    if (state.fullScreen) {
      // s.width = state.w
      // s.height = state.h
      // s.transform = `translate(-50%, -50%) scale3d(${state.scaleX},${state.scaleY},1) `
      // s.transformOrigin = "center"
      // s.zoom = Math.min(state.scaleX, state.scaleY)
    }
    return s
  }, [state.fullScreen, state.w, state.h, state.scaleX, state.scaleY])
  if (!ready) {
    return null
  }
  return (
    <div
      className={"ct-map" + (state.fullScreen ? " fullScreen" : "")}
      ref={refCon}
      style={{ height: "100%" }}
    >
      {/* <div className="mask-full">
        <div
          className="btn-exit"
          onClick={() => setState({ fullScreen: false })}
        >
          退出
        </div>
        {state.fullScreen && <MapIndoor />}
      </div> */}
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={wrapperStyle} className="map-wrapper">
          <div id={chartsDomId} style={{ height: "100%" }}></div>
        </div>
      </div>
      {props.indoorVisible && <LayerHeat visible={zoom > 15} map={mapIns} />}
      {props.indoorVisible && <LayerIndoor visible={zoom > 17} map={mapIns} />}
      {props.indoorVisible && (
        <LabelMarker
          visible={zoom < 17}
          map={mapIns}
          onClick={setMapFullScreen}
        />
      )}
      {!props.indoorVisible && <LayerAreaGeo visible map={mapIns} />}
      {!props.indoorVisible && (
        <LayerAreaHeat visible={zoom > 15} map={mapIns} />
      )}
    </div>
  )
}

export default Map
